var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.stage === 1
      ? _c("section", { staticClass: "Signup" }, [
          !_vm.sentEmail
            ? _c("div", [
                _c("h1", [_vm._v(_vm._s(_vm.$t("page.signUp.title")))]),
                _c("div", { staticClass: "notice" }, [
                  _vm._v(" " + _vm._s(_vm.$t("page.signUp.description")) + " ")
                ]),
                _c(
                  "form",
                  {
                    ref: "signupForm",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c("div", { ref: "email", staticClass: "email" }, [
                      _c("label", { attrs: { for: "email" } }, [
                        _vm._v(_vm._s(_vm.$t("page.signUp.emailLabel")))
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        attrs: {
                          id: "email",
                          placeholder: "Email",
                          type: "text"
                        },
                        domProps: { value: _vm.email },
                        on: {
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSubmit($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _c(
                        "span",
                        { ref: "emailErrorMessage", staticClass: "message" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("page.signUp.emailError.format"))
                          )
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      {
                        ref: "submitBtn",
                        staticClass: "submit-btns",
                        class: _vm.submitDisable ? "disabled" : ""
                      },
                      [
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: { click: _vm.handleSubmit }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("page.signUp.sendButton")) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "aside-btns" },
                      [
                        _c("router-link", { attrs: { to: "/login" } }, [
                          _vm._v(_vm._s(_vm.$t("page.signUp.logInLabel")))
                        ])
                      ],
                      1
                    )
                  ]
                )
              ])
            : _c("div", [
                !_vm.resend
                  ? _c("h1", [
                      _vm._v(_vm._s(_vm.$t("page.signUp.email.title")))
                    ])
                  : _c("h1", [
                      _vm._v(_vm._s(_vm.$t("page.signUp.reEmail.title")))
                    ]),
                _c("div", { staticClass: "verification-email" }, [
                  _vm._v(_vm._s(_vm.email))
                ]),
                _c("div", { staticClass: "notice" }, [
                  !_vm.resend
                    ? _c(
                        "span",
                        _vm._l(
                          _vm.$t("page.signUp.email.description"),
                          function(item, index) {
                            return _c("p", { key: index }, [
                              _vm._v(" " + _vm._s(item) + " ")
                            ])
                          }
                        ),
                        0
                      )
                    : _c(
                        "span",
                        _vm._l(
                          _vm.$t("page.signUp.reEmail.description"),
                          function(item, index) {
                            return _c("p", { key: index }, [
                              _vm._v(" " + _vm._s(item) + " ")
                            ])
                          }
                        ),
                        0
                      ),
                  _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: { click: _vm.resendVerifyEmail }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("page.signUp.reEmail.reSend")))]
                  ),
                  _vm._v(". ")
                ]),
                _c(
                  "div",
                  { staticClass: "primary-type-btns big-btns login-btn" },
                  [
                    _c("router-link", { attrs: { to: "/login" } }, [
                      _vm._v(_vm._s(_vm.$t("page.signUp.email.homeButton")))
                    ])
                  ],
                  1
                )
              ])
        ])
      : _vm.stage === 2
      ? _c("section", { staticClass: "Signup" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("page.signUp.inputInfo.title")))]),
          _c(
            "form",
            {
              ref: "signupForm",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "full-name" }, [
                _c("label", { attrs: { for: "fullName" } }, [
                  _vm._v(_vm._s(_vm.$t("page.signUp.inputInfo.name.title")))
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fullName,
                      expression: "fullName"
                    }
                  ],
                  attrs: {
                    id: "fullName",
                    placeholder: _vm.inputInfoNamePlaceholder,
                    type: "text",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.fullName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.fullName = $event.target.value
                    }
                  }
                })
              ]),
              _c(
                "div",
                { staticClass: "country" },
                [
                  _c("label", { attrs: { for: "country" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("page.signUp.inputInfo.country.title"))
                    )
                  ]),
                  _c(
                    "Select",
                    {
                      attrs: {
                        id: "country",
                        label: "countryName",
                        placeholder: _vm.inputInfoCountryPlaceholder,
                        components: {
                          OpenIndicator: _vm.OpenIndicator,
                          Deselect: _vm.Deselect
                        },
                        options: _vm.countryList
                      },
                      model: {
                        value: _vm.selectedCountry,
                        callback: function($$v) {
                          _vm.selectedCountry = $$v
                        },
                        expression: "selectedCountry"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vs__no-options",
                          attrs: { slot: "no-options" },
                          slot: "no-options"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "page.signUp.inputInfo.country.errorMessage"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.selectedCountry.countryName === _vm.nationAmerica
                ? _c(
                    "div",
                    { staticClass: "states" },
                    [
                      _c("div", { staticClass: "states-information" }, [
                        _c("label", { attrs: { for: "states" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("page.signUp.inputInfo.states.title"))
                          )
                        ]),
                        _vm._m(0),
                        _c("div", { staticClass: "notice-information" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("page.signUp.inputInfo.states.tooltip")
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.showText,
                            expression: "showText"
                          }
                        ],
                        staticClass: "inputClass",
                        attrs: { type: "text", readonly: "" },
                        domProps: { value: _vm.showText },
                        on: {
                          focus: _vm.showPopup,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.showText = $event.target.value
                          }
                        }
                      }),
                      _c("LicenseStates", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.licenseStatesPopup,
                            expression: "licenseStatesPopup"
                          }
                        ],
                        ref: "createLicenseStatesPopup",
                        attrs: {
                          "all-states": _vm.statesList,
                          "license-states-info": _vm.createLicenseStatesPopup,
                          "handle-create-license-states-popup-close":
                            _vm.handleCreateLicenseStatesPopupClose,
                          "set-checked-states": _vm.setCheckedStates,
                          "set-selected-states": _vm.setSelectedStates
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "gender" }, [
                _c("label", { attrs: { for: "Male" } }, [
                  _vm._v(_vm._s(_vm.$t("page.signUp.inputInfo.gender.title")))
                ]),
                _c(
                  "div",
                  { staticClass: "gender-radio" },
                  _vm._l(_vm.genderList, function(type, index) {
                    return _c("span", { key: index }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedGender,
                            expression: "selectedGender"
                          }
                        ],
                        attrs: { id: type, type: "radio" },
                        domProps: {
                          value: type,
                          checked: _vm._q(_vm.selectedGender, type)
                        },
                        on: {
                          change: function($event) {
                            _vm.selectedGender = type
                          }
                        }
                      }),
                      _c("label", { attrs: { for: type } }, [
                        _vm._v(_vm._s(_vm.inputInfoGenderOption(type)))
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _c("div", { staticClass: "mobile" }, [
                _c("label", { attrs: { for: "mobile" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("page.signUp.inputInfo.mobilePhone.title"))
                  )
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mobileNumber,
                      expression: "mobileNumber"
                    }
                  ],
                  attrs: {
                    id: "mobile",
                    placeholder: _vm.inputInfoMobilePhonePlaceholder,
                    type: "text",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.mobileNumber },
                  on: {
                    keydown: _vm.onlyNumber,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mobileNumber = $event.target.value
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "therapist-type" }, [
                _c("label", { attrs: { for: "OT" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("page.signUp.inputInfo.providerType.title"))
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "therapist-type-radio" },
                  _vm._l(_vm.therapistTypeList, function(type, index) {
                    return _c("span", { key: index }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedTherapistType,
                            expression: "selectedTherapistType"
                          }
                        ],
                        attrs: { id: type, type: "radio" },
                        domProps: {
                          value: type,
                          checked: _vm._q(_vm.selectedTherapistType, type)
                        },
                        on: {
                          change: function($event) {
                            _vm.selectedTherapistType = type
                          }
                        }
                      }),
                      _c("label", { attrs: { for: type } }, [
                        _vm._v(_vm._s(_vm.inputInfoProviderTypeOption(type)))
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "work-place",
                  class: _vm.clinicCodeCheck ? "" : "wrong"
                },
                [
                  _c("label", { attrs: { for: "Neofect" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("page.signUp.inputInfo.workPlace.title"))
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "work-place-radio" },
                    _vm._l(_vm.workplaceList, function(type, index) {
                      return _c("span", { key: index }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedWorkplace,
                              expression: "selectedWorkplace"
                            }
                          ],
                          attrs: { id: type, type: "radio" },
                          domProps: {
                            value: type,
                            checked: _vm._q(_vm.selectedWorkplace, type)
                          },
                          on: {
                            change: function($event) {
                              _vm.selectedWorkplace = type
                            }
                          }
                        }),
                        _c("label", { attrs: { for: type } }, [
                          _vm._v(_vm._s(_vm.inputInfoWorkPlaceOption(type)))
                        ])
                      ])
                    }),
                    0
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.clinicCode,
                        expression: "clinicCode"
                      }
                    ],
                    attrs: {
                      id: "clinic",
                      type: "text",
                      autocomplete: "off",
                      placeholder: _vm.inputInfoWorkPlacePlaceholder,
                      disabled: _vm.selectedWorkplace === "Neofect"
                    },
                    domProps: { value: _vm.clinicCode },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.clinicCode = $event.target.value
                      }
                    }
                  }),
                  _c("span", { staticClass: "message" }, [
                    _vm._v(" " + _vm._s(_vm.clinicCodeWrongMessage) + " ")
                  ])
                ]
              ),
              _c("div", { staticClass: "email" }, [
                _c("label", { attrs: { for: "email" } }, [
                  _vm._v(_vm._s(_vm.$t("page.signUp.inputInfo.email.title")))
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  attrs: {
                    id: "email",
                    placeholder: "Email",
                    type: "text",
                    disabled: "",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "password",
                  class: _vm.passwordCheck ? "" : "wrong"
                },
                [
                  _c("label", { attrs: { for: "password" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("page.signUp.inputInfo.password.title"))
                    )
                  ]),
                  _vm.passwordType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        attrs: {
                          id: "password",
                          placeholder: _vm.inputInfoPasswordPlaceholder,
                          autocomplete: "off",
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password)
                            ? _vm._i(_vm.password, null) > -1
                            : _vm.password
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.password = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password = $$c
                            }
                          }
                        }
                      })
                    : _vm.passwordType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        attrs: {
                          id: "password",
                          placeholder: _vm.inputInfoPasswordPlaceholder,
                          autocomplete: "off",
                          type: "radio"
                        },
                        domProps: { checked: _vm._q(_vm.password, null) },
                        on: {
                          change: function($event) {
                            _vm.password = null
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        attrs: {
                          id: "password",
                          placeholder: _vm.inputInfoPasswordPlaceholder,
                          autocomplete: "off",
                          type: _vm.passwordType
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                  _vm.passwordType === "text"
                    ? _c(
                        "button",
                        {
                          staticClass: "password-show",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.passwordHidden("default")
                            }
                          }
                        },
                        [_vm._m(1)]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "password-show",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.passwordShow("default")
                            }
                          }
                        },
                        [_vm._m(2)]
                      ),
                  _c("span", { staticClass: "message" }, [
                    _vm._v(" " + _vm._s(_vm.passwordWrongMessage) + " ")
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "confirm-password",
                  class: _vm.confirmPasswordCheck ? "" : "wrong"
                },
                [
                  _c("label", { attrs: { for: "confirmpassword" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("page.signUp.inputInfo.rePassword.title"))
                    )
                  ]),
                  _vm.confirmPasswordType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmPassword,
                            expression: "confirmPassword"
                          }
                        ],
                        attrs: {
                          id: "confirmpassword",
                          placeholder: _vm.inputInfoRePasswordPlaceholder,
                          autocomplete: "off",
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.confirmPassword)
                            ? _vm._i(_vm.confirmPassword, null) > -1
                            : _vm.confirmPassword
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.confirmPassword,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.confirmPassword = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.confirmPassword = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.confirmPassword = $$c
                            }
                          }
                        }
                      })
                    : _vm.confirmPasswordType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmPassword,
                            expression: "confirmPassword"
                          }
                        ],
                        attrs: {
                          id: "confirmpassword",
                          placeholder: _vm.inputInfoRePasswordPlaceholder,
                          autocomplete: "off",
                          type: "radio"
                        },
                        domProps: {
                          checked: _vm._q(_vm.confirmPassword, null)
                        },
                        on: {
                          change: function($event) {
                            _vm.confirmPassword = null
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmPassword,
                            expression: "confirmPassword"
                          }
                        ],
                        attrs: {
                          id: "confirmpassword",
                          placeholder: _vm.inputInfoRePasswordPlaceholder,
                          autocomplete: "off",
                          type: _vm.confirmPasswordType
                        },
                        domProps: { value: _vm.confirmPassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.confirmPassword = $event.target.value
                          }
                        }
                      }),
                  _vm.confirmPasswordType === "text"
                    ? _c(
                        "button",
                        {
                          staticClass: "password-show",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.passwordHidden("confirm")
                            }
                          }
                        },
                        [_vm._m(3)]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "password-show",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.passwordShow("confirm")
                            }
                          }
                        },
                        [_vm._m(4)]
                      ),
                  _c("span", { staticClass: "message" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "page.signUp.inputInfo.rePassword.error.notMatch"
                        )
                      )
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "submit-btns",
                  class: _vm.submitDisable ? "disabled" : ""
                },
                [
                  _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: { click: _vm.handleSubmit }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("page.signUp.inputInfo.signUpButton")) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      : _vm.stage === 3
      ? _c("section", { staticClass: "Signup" }, [
          _c("h1", [
            _vm._v(
              _vm._s(_vm.$t("page.signUp.signUpDone.title")) +
                ", " +
                _vm._s(_vm.fullName + "!")
            )
          ]),
          _c("div", { staticClass: "notice" }, [
            _vm._v(_vm._s(_vm.$t("page.signUp.signUpDone.description")))
          ]),
          _c(
            "div",
            { staticClass: "primary-type-btns big-btns login-btn" },
            [
              _c("router-link", { attrs: { to: "/login" } }, [
                _vm._v(_vm._s(_vm.$t("page.signUp.signUpDone.logIn")))
              ])
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-ic_info_circle" }, [
      _c("span", { staticClass: "path1" }),
      _c("span", { staticClass: "path2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-ic_eye_hide" }, [
      _c("span", { staticClass: "path1" }),
      _c("span", { staticClass: "path2" }),
      _c("span", { staticClass: "path3" }),
      _c("span", { staticClass: "path4" }),
      _c("span", { staticClass: "path5" }),
      _c("span", { staticClass: "path6" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-ic_eye_show" }, [
      _c("span", { staticClass: "path1" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-ic_eye_hide" }, [
      _c("span", { staticClass: "path1" }),
      _c("span", { staticClass: "path2" }),
      _c("span", { staticClass: "path3" }),
      _c("span", { staticClass: "path4" }),
      _c("span", { staticClass: "path5" }),
      _c("span", { staticClass: "path6" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-ic_eye_show" }, [
      _c("span", { staticClass: "path1" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }